import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as lmsAction from "../../../redux/actions/lmsAction";
import { ORG_ID, PAGE_SIZE } from "../../../constant/constant";
import AddScormFile from "../component/scormfile/addScormFile";
import Loader from "../../../library/common/Loader";

function AddScormFilesContainer() {
  const dispatch = useDispatch();
  const scormUploadCoursesList = useSelector(
    (state) => state.scormUploadCoursesList
  );
  const getScormUploadCourses = async (data) => {
    dispatch(lmsAction.getScormUploadCoursesList(data));
  };

  return (
    <>
      {scormUploadCoursesList?.isLoading && <Loader />}
      <AddScormFile
        scormUploadCoursesList={scormUploadCoursesList}
        getScormUploadCourses={getScormUploadCourses}
      />
    </>
  );
}

export default AddScormFilesContainer;
